export default "__VITE_ASSET__C6I7YgRH__"